import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = {
    "no-gutters": "",
    class: "my-4 d-flex align-center justify-end"
};
import { reactive, ref, } from 'vue';
import createStoreFormRules from '@/form/form-rules/storeManagement';
import { isString } from '@/utils';
import { routeName } from '@/constants/routeName';
import { errorCode } from '@/error';
import { i18n } from '@/locales';
import AddressFormVM from '@/view-model/AddressFormVM';
import { useRouter } from 'vue-router';
import StoreCreateBasicInfo from '@/views/StoreManagement/StoreCreate/BasicInfo.vue';
import StoreCreateManagementFee from '@/views/StoreManagement/StoreCreate/ManagementFee.vue';
import StoreCreateReceptionOperation from '@/views/StoreManagement/StoreCreate/ReceptionOperation.vue';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { objDeepCompare } from '@/utils/object';
import vuexStore from '@/vuex-store';
const lc = 'views.store_management.';
const formRulesLc = 'form_rules.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const router = useRouter();
        const showSuccess = (payload) => vuexStore.dispatch(snackbarActionType.showSuccess, payload);
        const showError = (payload) => vuexStore.dispatch(snackbarActionType.showError, payload);
        const showInfo = (payload) => vuexStore.dispatch(snackbarActionType.showInfo, payload);
        const postStore = (payload) => vuexStore.dispatch('storeManagement/storeCreate/postStore', payload);
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const formRules = createStoreFormRules(formRulesLc);
        const createFormData = () => ({
            name: '',
            addressFormData: new AddressFormVM({}),
            memo: '',
            phone: '',
            fax: '',
            restDays: [],
            workingTime: {
                on: '00:00',
                off: '23:59',
            },
            depositBaromoney: 0,
            withdrawalBankCode: null,
            withdrawalBankAccount: '',
            withdrawalBankOwner: '',
            businessNumber: '',
            ceoAdditionalInfo: {
                type: 'REG_NUMBER',
                ceoResidentRegistrationNumber: '',
            },
            businessName: '',
            ceoName: '',
            ceoPhone: '',
            ceoEmail: '',
            businessCondition: '',
            businessType: '',
            adjustmentType: null,
            deliveryPayFlag: 'MONTHLY_FIXED_AMOUNT',
            vatRateMonthly: 0,
            deliveryFeePerOrder: 0,
            deliveryFeeRatePerOrder: 0,
            distanceProduct: 0,
            deliveryPayType: '2',
            vatRate: 0,
            hubDeliveryPrePaymentFee: 0,
            hubDeliveryPrePaymentFeeRate: 0,
            goodsPayRestrictType: 'NONE',
            goodsPayType: 'BAROMONEY',
            isCashReceiptsRequired: false,
            cookingTime: 15,
            dayDeliveryCount: 0,
            deliveryCancelTime: 60,
            orderLimitBaromoney: 0,
            isInsufficientBaromoneyUnAccept: false,
            isDeliveryChargeNonSettingUnAccept: false,
            addChargeUseYn: 'Y',
            deliveryFeeMonthly: 0,
            deliveryFeeMonthlyDay: 0,
            endDeliveryCount: 0,
            deliveryManagementFeePerOrder: 0.0,
            deliveryManagementFeeRatePerOrder: 0,
            isSendBaromoneyRequired: false,
            isMonthlyChargeUnAccept: false,
        });
        const formRef = ref(null);
        const createdFormData = createFormData();
        const createdOriginFormData = createFormData();
        const formData = reactive(createdFormData);
        const originFormData = reactive(createdOriginFormData);
        const setFormData = (key, value) => {
            const splited = key.split('.');
            const [first, second, third,] = splited;
            if (third) {
                formData[first][second][third] = value;
                return;
            }
            if (second) {
                formData[first][second] = value;
                return;
            }
            formData[first] = value;
        };
        const _validateForm = () => formRef.value.validate();
        const goToMainPage = () => {
            router.push({
                name: routeName.STORE_MANAGEMENT,
            });
        };
        // TODO formData 트랜스폼 레이어 필요
        const convertSubmitDataToPayload = (list) => list.reduce((acc, [key, value,]) => {
            if (key === 'deliveryFeeMonthlyDay') {
                acc[key] = isString(value)
                    ? value.replace(/-/g, '')
                    : value;
                return acc;
            }
            if (key === 'workingTime') {
                const { on, off, } = value;
                acc[key] = on.replace(':', '') + off.replace(':', '');
                return acc;
            }
            if (key === 'ceoAdditionalInfo') {
                const { ceoResidentRegistrationNumber } = value;
                acc.ceoResidentRegistrationNumber = ceoResidentRegistrationNumber;
            }
            if (key === 'addressFormData') {
                Object.entries(value).forEach(([addressDTOKey, addressDTOValue,]) => {
                    const replacedKey = addressDTOKey
                        .replace('_', '');
                    if (replacedKey === 'location') {
                        const { longitude, latitude } = addressDTOValue;
                        acc.longitude = longitude;
                        acc.latitude = latitude;
                        return acc;
                    }
                    if (replacedKey === 'enclosedRoad' || typeof addressDTOValue !== 'string') {
                        return acc;
                    }
                    const capitalizedKey = replacedKey.charAt(0).toUpperCase() + replacedKey.slice(1);
                    acc[`address${capitalizedKey}`] = addressDTOValue;
                    return acc;
                });
            }
            acc[key] = value;
            return acc;
        }, {});
        const _onSubmit = async (submitData) => {
            try {
                const submitDataList = Object.entries(submitData);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { addressFormData, ceoAdditionalInfo, ...filteredList } = convertSubmitDataToPayload(submitDataList);
                const response = await postStore(filteredList);
                if (!response.isSuccess) {
                    // res status 200이나 라이더 등록이 불가한 경우
                    if (response.reason || response.message) {
                        showError({
                            message: errorCode[response.reason] ?? response.message,
                        });
                        return;
                    }
                    // 네트워크, 서버 등 알 수 없는 에러의 경우
                    showError({
                        message: i18n.t('common.unknown_error'),
                    });
                    return;
                }
                showSuccess({
                    message: i18n.t(`${lc}create_store_info_success`),
                });
                goToMainPage();
            }
            catch (error) {
                console.log('postStore error', error);
                showError({
                    message: i18n.t('common.failure'),
                });
            }
        };
        const handleSubmitForm = async () => {
            // fail
            const { valid } = await _validateForm();
            if (!valid) {
                return showInfo({
                    message: i18n.t('common.form_validation_error'),
                });
            }
            // success
            return _onSubmit(formData);
        };
        const handleClickCancelForm = async () => {
            const isSameData = objDeepCompare(originFormData, formData);
            if (isSameData) {
                goToMainPage();
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: `${i18n.t(`${lc}registration`)} ${i18n.t('common.cancel')}`,
                bodyContent: i18n.t('common.confirm_before_cancel'),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            });
            if (isConfirmOk) {
                goToMainPage();
            }
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    class: "create-store-wrapper",
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createVNode(StoreCreateBasicInfo, {
                            lc: lc,
                            "form-rules-lc": formRulesLc,
                            "form-rules": _unref(formRules),
                            "form-data": formData,
                            onSetFormData: setFormData
                        }, null, 8 /* PROPS */, ["form-rules", "form-data"]),
                        _createVNode(StoreCreateManagementFee, {
                            lc: lc,
                            "form-rules-lc": formRulesLc,
                            "form-rules": _unref(formRules),
                            "form-data": formData,
                            onSetFormData: setFormData
                        }, null, 8 /* PROPS */, ["form-rules", "form-data"]),
                        _createVNode(StoreCreateReceptionOperation, {
                            lc: lc,
                            "form-rules-lc": formRulesLc,
                            "form-rules": _unref(formRules),
                            "form-data": formData,
                            onSetFormData: setFormData
                        }, null, 8 /* PROPS */, ["form-rules", "form-data"]),
                        _createElementVNode("div", _hoisted_2, [
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                class: "mr-2",
                                onClick: handleClickCancelForm
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "width-s": true,
                                        "size-xl": true
                                    }
                                ]
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.registration')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        primary: true,
                                        "width-s": true,
                                        "size-xl": true
                                    }
                                ]
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
